import { Box, Alert } from '@mui/material';
import { Loader } from '@sm-dashboard/ui-components';
import { HeatmapView } from './HeatmapView';
import { HeatmapContact, HeatmapMode } from './useHeatmapData';
import { useCentersData } from './useCentersData';
import { useBranchPolygon } from './useBranchPolygon';

interface HeatmapMapContainerProps {
  contacts: HeatmapContact[];
  mode: HeatmapMode;
  loading: boolean;
  error: unknown;
}

const CENTERED_BOX_SX = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100%',
  width: '100%'
};

export const HeatmapMapContainer = ({ contacts, mode, loading, error }: HeatmapMapContainerProps) => {
  const { centers, error: centersError } = useCentersData();
  const { polygon: branchPolygon } = useBranchPolygon();

  if (loading) {
    return (
      <Box sx={CENTERED_BOX_SX}>
        <Loader />
      </Box>
    );
  }

  if (error) {
    return (
      <Box sx={{ p: 2 }}>
        <Alert severity="error">שגיאה בטעינת נתוני מפת החום</Alert>
      </Box>
    );
  }

  // Show message only if there are no contacts AND no polygon
  // If there's a polygon but no contacts, still show the map with the boundary
  if ((!contacts || contacts.length === 0) && !branchPolygon) {
    return (
      <Box sx={CENTERED_BOX_SX}>
        <Alert severity="info">אין נתונים להצגה. נסה לשנות את הפילטרים.</Alert>
      </Box>
    );
  }


  if (centersError) {
    console.warn('Failed to load centers:', centersError);
  }

  return <HeatmapView contacts={contacts} centers={centers || []} mode={mode} branchPolygon={branchPolygon} />;
};
